module.exports = __webpack_public_path__ + "img/ccme-logo.9177509d.png";